/**
 * 画面の向きの目印を <html> に付ける（CSS はこのクラスでレイアウトを切り替える）。
 *   landscape       … 端末が横向き
 *   phone-landscape … スマホが横向き（左に地図・右にナビの表示）
 *
 * 判定は「表示領域の横幅が、画面の短い辺より広いか」で行う。
 * - CSS の (orientation: landscape) は表示領域の縦横で決まるので、iPhone 縦向きで文字入力のキーボードが出て
 *   高さが縮むと横向き扱いになる（実機で発生）。横幅はキーボードでは変わらない
 * - screen.orientation は環境によって実際の向きと食い違うことがある（ヘッドレス Chrome で発生）ので使わない
 * - iOS の screen.width/height は向きで入れ替わらないが、短い辺で比べるので関係ない
 */
const shortSide = () => Math.min(screen.width, screen.height);

function isLandscape(): boolean {
  return window.innerWidth > shortSide() + 20;
}

/** スマホか（画面の短い辺が 500px 未満） */
const isPhone = () => shortSide() < 500;

export function isPhoneLandscape(): boolean {
  return document.documentElement.classList.contains('phone-landscape');
}

export function watchLayout(onChange?: () => void): void {
  const apply = () => {
    const landscape = isLandscape();
    const root = document.documentElement.classList;
    const before = root.contains('landscape') + '/' + root.contains('phone-landscape');
    root.toggle('landscape', landscape);
    root.toggle('phone-landscape', landscape && isPhone());
    if (before !== root.contains('landscape') + '/' + root.contains('phone-landscape')) onChange?.();
  };
  apply();
  screen.orientation?.addEventListener('change', apply);
  window.addEventListener('orientationchange', apply);
  window.addEventListener('resize', apply);
}
